import React from 'react';
import { FormattedMessage } from 'react-intl';
import { P, TextLink, Stack } from '@manulife/mux';
import {
  FormattedRichMessage,
  RealmSpecific,
  ContentPage,
  useCoBranding,
  useRealm,
  useRichIntl,
  REALMS,
} from 'ciam-self-service-shared';
import Page from '../common/Page';
import { CONTACT_US } from './constant';
import AnalyticsDataLayer from '../common/Analytics';
import ContactPanel from './ContactPanel';
import { Helmet } from 'react-helmet-async';

// See https://confluence.manulife.ca/display/CETES/Contact+Us
const ContactProducts = {
  [REALMS.CUSTOMER]: [
    'groupBenefits',
    'groupRetirement',
    'insuranceSecureSite',
    'bank',
    'manulifeSecurities',
    'manulifeInvestments',
    'manulifeMutualFunds',
    'manulifeVitality',
    'manulifePrivateWealth',
    'secureServe',
  ],
  [REALMS.ADVISOR]: [
    'advisorPortal',
    'wealthAdvisorSite',
    'groupRetirement',
    'sellHealthPlans',
    'investmentsAdvisorSite',
    'travelInsurance',
  ],
  [REALMS.SPONSOR]: ['groupBenefits', 'groupRetirement'],
  [REALMS.MCI]: ['mortgageProtectionPlan', 'creditSecurityPlan'],
};

function Contact() {
  const intl = useRichIntl();
  const realm = useRealm();
  const coBranding = useCoBranding();

  const products = ContactProducts[realm] || [];

  if (coBranding?.brand?.contactUrl) {
    window.location.replace(coBranding?.brand?.contactUrl);
    return null;
  }

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <Page
        title={intl.formatMessage({ id: 'contact.page.title' })}
        description={intl.formatMessage({ id: 'contact.page.meta.description' })}
        heading={intl.formatMessage({ id: 'contact.page.heading' })}
      >
        <AnalyticsDataLayer pageName={CONTACT_US} />
        <ContentPage heading={<FormattedMessage id="contact.page.heading" />} contentColumns={7}>
          <Stack direction="column" align="stretch">
            {products.map((product) => (
              <ContactPanel key={product} product={product} />
            ))}
          </Stack>

          <RealmSpecific showFor={[REALMS.CUSTOMER, REALMS.ADVISOR, REALMS.SPONSOR]}>
            <P>
              <FormattedRichMessage
                id="contact.page.fallback"
                values={{
                  ManulifeCaContactUsLink: function ManulifeCaContactUsLink(chunks) {
                    return (
                      <TextLink isExternal to={intl.formatMessage({ id: `contact.page.fallback.${realm}.contactUrl` })}>
                        {chunks}
                      </TextLink>
                    );
                  },
                  ManulifeCaLink: function ManulifeCaLink(chunks) {
                    return (
                      <TextLink
                        isExternal
                        to={intl.formatMessage({ id: `contact.page.fallback.${realm}.manulifeCaUrl` })}
                      >
                        {chunks}
                      </TextLink>
                    );
                  },
                }}
              />
            </P>
          </RealmSpecific>
        </ContentPage>
      </Page>
    </>
  );
}

export default Contact;
